module.exports = __webpack_public_path__ + "static/media/bg-pattern.13c73f22.png";